import React from 'react';

import { getReport, IReport } from '~/src/dash/api/console-api';
import { ModelErrorPaper } from '~/src/dash/components/model-missing-permission';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { BidderReportFormView } from '~/src/dash/views/bidder-report-form-view';
import { LoadingView } from '~/src/dash/views/loading-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState {
  report?: IReport;
  loaded: boolean;
  err?: string;
}

export const BidderReportExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      report: {} as IReport,
      loaded: false,
      err: undefined,
    };

    componentDidMount() {
      const loc = parseLocation(this.props.location.pathname);
      getReport({
        query: {
          publisher_id: this.props.session.publisher.ID,
          report_id: loc.report,
        },
      })
        .then((report: IReport) => {
          this.setState({
            report,
            loaded: true,
          });
        })
        .catch((err: Error) => {
          this.setState({
            loaded: false,
            err: err.toString(),
          });
        });
    }

    render() {
      if (this.state.err !== undefined) {
        return <ModelErrorPaper err={this.state.err || ''} />;
      }

      return (
        <>
          {this.state.loaded ? (
            <BidderReportFormView report={this.state.report} />
          ) : (
            <LoadingView active={true} text='Loading the report settings' />
          )}
        </>
      );
    }
  },
);
